import IconBase from './IconBase'
import { ReactComponent } from './light/draw-square.svg'

const UnknownBlockIcon = (props: any) => <IconBase {...props} ReactComponent={ReactComponent} />

export default UnknownBlockIcon
